export default __webpack_public_path__ + "static/gantmodern-regular-bc7c376ffbefa539825dbc71dd303491.woff2";